// "Load more" pagination for sections/main-collection-product-grid.liquid.
// Fetches the next page through the Section Rendering API and appends its cards.
if (!customElements.get('pg-load-more')) {
  customElements.define(
    'pg-load-more',
    class PgLoadMore extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-button]');
        this.status = this.querySelector('[data-status]');
        this.bar = this.querySelector('[data-bar]');
        this.classList.add('is-enhanced');
        if (this.button) this.button.addEventListener('click', this.onClick.bind(this));
      }

      onClick(event) {
        event.preventDefault();
        const nextUrl = this.dataset.nextUrl;
        if (!nextUrl || this.classList.contains('is-loading')) return;
        this.classList.add('is-loading');

        const url = new URL(nextUrl, window.location.origin);
        url.searchParams.set('section_id', this.dataset.sectionId);

        fetch(url)
          .then((response) => response.text())
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const grid = document.getElementById('product-grid');
            const newItems = doc.querySelectorAll('#product-grid > li');
            if (!grid || newItems.length === 0) throw new Error('No products returned');

            const firstNew = newItems[0];
            newItems.forEach((item) => grid.appendChild(document.importNode(item, true)));
            if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(grid);

            const next = doc.querySelector('pg-load-more');
            this.update(next, grid.children.length);

            // Move focus to the first new product for keyboard and screen-reader users
            const firstLink = grid.children[grid.children.length - newItems.length]?.querySelector('a[href]:not([tabindex="-1"])');
            if (firstLink && firstNew) firstLink.focus({ preventScroll: true });
          })
          .catch(() => {
            // Fall back to a normal page load
            window.location.href = nextUrl;
          })
          .finally(() => this.classList.remove('is-loading'));
      }

      update(next, shown) {
        const total = Number(this.dataset.total) || shown;
        if (this.status && this.dataset.shownTemplate) {
          this.status.textContent = this.dataset.shownTemplate.replace('[shown]', shown).replace('[total]', total);
        }
        if (this.bar) this.bar.style.width = `${Math.min(100, (shown / total) * 100)}%`;

        const nextButton = next && next.querySelector('[data-button]');
        if (nextButton) {
          this.dataset.nextUrl = next.dataset.nextUrl;
          this.button.href = next.dataset.nextUrl;
        } else {
          this.dataset.nextUrl = '';
          if (this.button) this.button.remove();
        }
      }
    }
  );
}
